import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'

import { AnalyticsService } from './analytics.service'
import { PlausibleAnalytics } from './plausible-analytics.service'

export function providePlausibleAnalytics(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: AnalyticsService, useClass: PlausibleAnalytics }])
}
